import { useState } from 'react'
import { Button, WidgetGrid } from '@cinesend/ui-kit'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import Page from '../../components/layouts/page'
import isEmpty from '../../helpers/is_empty'
import useDashboardLayout from './use_dashboard_layout'
import AddWidgetModal from './add_widget_modal'
import DetailsWidget from './widgets/details'
import IssuesSummaryWidget from './widgets/issues_summary'
import ProgressWidget from './widgets/progress'
import DataWidget from './widgets/data'

const Dashboard = () => {
  const { airlineID, cycleID } = useParams()
  const { data: airline } = useQuery(['airlines/', airlineID])
  const { data: cycle, error, isLoading } = useQuery(['cycles/', cycleID])
  const [addOpen, setAddOpen] = useState(false)
  const {
    displayOrder,
    editing,
    dragId,
    startEditing,
    finishEditing,
    removeWidget,
    setWidgetVisible,
    onDragStart,
    onDragOver,
    onDrop,
    onDragEnd,
  } = useDashboardLayout()

  const widgetProps = (id) => ({
    id,
    editing,
    isDragging: dragId === id,
    onDragStart: onDragStart(id),
    onDragOver,
    onDrop: onDrop(id),
    onDragEnd,
    onRemove: removeWidget,
  })

  const widgets = {
    details: <DetailsWidget key='details' airline={airline} cycle={cycle} {...widgetProps('details')} />,
    issues: <IssuesSummaryWidget key='issues' cycleID={cycleID} {...widgetProps('issues')} />,
    progress: <ProgressWidget key='progress' cycleID={cycleID} {...widgetProps('progress')} />,
    data: <DataWidget key='data' cycleID={cycleID} {...widgetProps('data')} />,
  }

  return (
    <Page
      title='Dashboard'
      pending={isLoading}
      error={error || isEmpty(cycle)}
      buttons={[
        editing ? (
          <Button key='manage-widgets' variant='secondary' onClick={() => setAddOpen(true)}>
            Manage widgets
          </Button>
        ) : null,
        <Button
          key='edit-dashboard'
          variant={editing ? 'primary' : 'secondary'}
          onClick={editing ? finishEditing : startEditing}
        >
          {editing ? 'Done' : 'Edit dashboard'}
        </Button>,
      ].filter(Boolean)}
    >
      <WidgetGrid>{displayOrder.map((id) => widgets[id])}</WidgetGrid>
      {addOpen ? (
        <AddWidgetModal visibleIds={displayOrder} onToggle={setWidgetVisible} onClose={() => setAddOpen(false)} />
      ) : null}
    </Page>
  )
}

export default Dashboard
